import type { IDBPDatabase } from "@dumbmatter/idb";
import Cache from "./Cache.ts";
import connectLeague, { type LeagueDB } from "./connectLeague.ts";
import connectMeta from "./connectMeta.ts";
import * as getCopies from "./getCopies/index.ts";
import * as getCopy from "./getCopy/index.ts";

const idb = {
	cache: new Cache(),
	getCopies,
	getCopy,
	// Filled by league switching/thread bootstrap before league-scoped callers run.
	league: undefined as unknown as IDBPDatabase<LeagueDB>,
	meta: await connectMeta(),
};

export { Cache, connectLeague, connectMeta, idb };
export { default as getAll } from "./getAll.ts";
export { default as reset } from "./reset.ts";
